import React from 'react';
import PropTypes from 'prop-types';
import history from '../../history';
import { withRouter } from 'react-router-dom';
import withAuthInfo from '../../utils/withAuthInfo';

const HeaderMenu = ({ items = [], location, authInfo }) => {
  const renderOpcionMenu = (icon, label, image, svg, subMenus, url) => {
    let optionRender = null;

    if (icon != null)
      optionRender = (
        <>
          <i className={`fas fa-${icon}`}></i>
          <label>{label}</label>
          {subMenus && <i className={'fas fa-angle-down'}></i>}
        </>
      );

    if (image != null)
      optionRender = (
        <>
          <img src={image} alt='Icon for menu' /> <label>{label}</label>
          {subMenus && <i className={'fas fa-angle-down'}></i>}
        </>
      );

    if (svg != null) {
      optionRender = (
        <>
          <img src={svg} className='iconosMenu' />
          <label onClick={() => (url !== undefined ? history.push(url, { opcMenu: label }) : null)}>
            {label}
          </label>
          {subMenus && (
            <>
              <i className={'fas fa-angle-down'}></i>
              <ul
                className={`sub_menu ${
                  subMenus.length === 1 ? 'sub_menu_one_option' : 'sub_menu_multi_option'
                }`}
              >
                {subMenus.map((sm, k) => {
                  if (sm.roles && !sm.roles.find((x) => x === authInfo.rol)) return null;
                  return (
                    <li
                      onClick={() => {
                        if (sm.action) {
                          sm.action(); // Call the action if it exists
                        } else {
                          history.push(sm.route, { opcMenu: label, subMenu: sm.label });
                        }
                      }}
                      key={k}
                    >
                      <img className='icono-subMenu' src={sm.icon} alt='Icon for menu' />
                      <label style={{ margin: 0, cursor: 'pointer', whiteSpace: 'break-spaces' }}>
                        {sm.label}
                      </label>
                    </li>
                  );
                })}
              </ul>
            </>
          )}
        </>
      );
    }

    return optionRender;
  };

  return (
    <div id='menu' className='menu'>
      <ul>
        {items.map(({ label, image, icon, svg, subMenus, roles, url, action }, key) => {
          const isOptionSelected = subMenus && subMenus.some((z) => z.route == location.pathname);
          if (roles && roles.some((x) => x === authInfo.rol))
            return (
              <>
                <li
                  className={isOptionSelected ? 'curretPage' : ''}
                  key={key}
                  onClick={() => {
                    if (action) {
                      action(); // Call the action function if defined
                    } else if (url !== undefined) {
                      history.push(url, { opcMenu: label });
                    }
                  }}
                >
                  {renderOpcionMenu(
                    icon,
                    label,
                    image,
                    svg,
                    subMenus,
                    url
                  )}
                </li>
              </>
            );
        })}
      </ul>
    </div>
  );
};

HeaderMenu.propTypes = {
  items: PropTypes.array.isRequired,
  location: PropTypes.any,
  authInfo: PropTypes.object.isRequired
};

export default withAuthInfo()(withRouter(HeaderMenu));
